export default __webpack_public_path__ + "static/media/bg-credit-usage-guide.49e2ab06.svg";